import { render, staticRenderFns } from "./courseInfo.vue?vue&type=template&id=b90d59ae&scoped=true&"
import script from "./courseInfo.vue?vue&type=script&lang=js&"
export * from "./courseInfo.vue?vue&type=script&lang=js&"
import style0 from "./courseInfo.vue?vue&type=style&index=0&id=b90d59ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90d59ae",
  null
  
)

export default component.exports